import { cva } from 'class-variance-authority'

export const empty = cva([
  'flex flex-col gap-3 justify-center  items-center p-3',
])
